var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcFullscreenExitFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 6,
    fill: "black",
    fillOpacity: 0.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7941 21.0784L22.7941 15.3921C22.7941 14.4446 22.026 13.6764 21.0784 13.6764C20.1309 13.6764 19.3628 14.4446 19.3628 15.3921L19.3628 19.3627L15.3922 19.3627C14.4446 19.3627 13.6765 20.1308 13.6765 21.0784C13.6765 22.0259 14.4446 22.7941 15.3922 22.7941L21.0784 22.7941C22.026 22.7941 22.7941 22.0259 22.7941 21.0784Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2059 21.0784L27.2059 15.3921C27.2059 14.4446 27.974 13.6764 28.9216 13.6764C29.8691 13.6764 30.6372 14.4446 30.6372 15.3921L30.6372 19.3627L34.6078 19.3627C35.5554 19.3627 36.3235 20.1308 36.3235 21.0784C36.3235 22.0259 35.5554 22.7941 34.6078 22.7941L28.9216 22.7941C27.974 22.7941 27.2059 22.0259 27.2059 21.0784Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0784 27.0098L15.3922 27.0098C14.4446 27.0098 13.6765 27.778 13.6765 28.7255C13.6765 29.6731 14.4446 30.4412 15.3922 30.4412L19.3628 30.4412L19.3628 34.6079C19.3628 35.5554 20.1309 36.3236 21.0784 36.3236C22.026 36.3236 22.7941 35.5554 22.7941 34.6079L22.7941 28.7255C22.7941 27.778 22.026 27.0098 21.0784 27.0098Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9216 27.0098L34.6078 27.0098C35.5554 27.0098 36.3235 27.778 36.3235 28.7255C36.3235 29.6731 35.5554 30.4412 34.6078 30.4412L30.6372 30.4412L30.6372 34.6079C30.6372 35.5554 29.8691 36.3236 28.9216 36.3236C27.974 36.3236 27.2059 35.5554 27.2059 34.6079L27.2059 28.7255C27.2059 27.778 27.974 27.0098 28.9216 27.0098Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFullscreenExitFilled);
export default __webpack_public_path__ + "static/media/ic_fullscreen_exit_filled.c7b1f997a1ec33c2ac5600bed9cb0be9.svg";
export { ForwardRef as ReactComponent };